import kMarkBlack from "../assets/k-mark.webp";
import kMarkRed from "../assets/k-mark-red.webp";

type Props = {
  className?: string;
  /** "ink" = black K with red star (light backgrounds), "ember" = red K with black star (dark backgrounds) */
  tone?: "ink" | "ember";
  sparkle?: boolean;
};

/**
 * Official K-mark from the brand assets.
 * Two opposing crescent halves with a center sparkle — exactly as in the brand book.
 */
export function KMark({ className, tone = "ink", sparkle: _sparkle = true }: Props) {
  const src = tone === "ember" ? kMarkRed : kMarkBlack;
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className={className}
      draggable={false}
    />
  );
}
